/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSlice = createReactComponent("outline", "slice", "IconSlice", [["path", { "d": "M3 19l15 -15l3 3l-6 6l2 2a14 14 0 0 1 -14 4", "key": "svg-0" }]]);

export { IconSlice as default };
//# sourceMappingURL=IconSlice.mjs.map
